import { render, staticRenderFns } from "./NewsInnerBanner.vue?vue&type=template&id=2921aae4&"
import script from "./NewsInnerBanner.vue?vue&type=script&lang=js&"
export * from "./NewsInnerBanner.vue?vue&type=script&lang=js&"
import style0 from "./NewsInnerBanner.vue?vue&type=style&index=0&id=2921aae4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports